import { createButton } from 'react-simple-wysiwyg';

import { Dotpoints01Icon } from '@/assets/icons/Dotpoints01Icon';

export default createButton('Unordered List', <Dotpoints01Icon />, 'insertUnorderedList');
